<template>
  <div class="ai-personal-infor" v-loading="historyAiLoading">
    <!-- 组件内容 -->
    <!--    <div>tipsType - {{tipsType}}</div>-->
    <p class="tips" v-if="tipsType">
      AI检索已完成，如需获取该人才最新信息，请启动【AI检索】实时获取全网公开履历信息!
    </p>
    <p class="tips" v-else>该人才信息尚未使用AI工具，可启动【AI检索】实时获取全网公开履历信息!</p>
    <el-button class="ai-search-btn" @click="startStream" :disabled="isStreaming">
      AI检索生成
      <el-tooltip
        class="item"
        effect="light"
        popper-class="definition-class"
        content="利用检索增强和大模型实现专家信息的全网搜索与生成"
        placement="top"
      >
        <img
          v-if="!isStreaming"
          style="width: 15px"
          :src="require('@/assets/images/talent/ai-tips.png')"
          alt=""
        />
        <img v-else style="width: 15px" :src="require('@/assets/images/talent/ai-tips2.png')" alt="" />
      </el-tooltip>
    </el-button>

    <!--  思考过程  -->
    <toggle-component :default-visible="true" v-if="computedThinkingMD">
      <div class="thinking-con" v-html="computedThinkingMD"></div>
    </toggle-component>

    <!--  历史思考过程  -->
    <toggle-component
      :default-visible="true"
      v-if="historyAiThinkingData && historyAiThinkingData.length"
    >
      <div class="thinking-con">
        <p class="url-item" v-for="(item, index) in historyAiThinkingData" :key="index">
          <a :href="item.url" target="_blank">{{ item.url }}</a>

          <span @click="lookUrlDetail(item.url, item.content)">查看详情</span>
        </p>
      </div>
    </toggle-component>

    <!-- 展示流式数据容器 -->
    <div v-if="computedAnswerMD.length" class="ai-infor-content" v-html="computedAnswerMD"></div>

    <!--  进入页面获取历史数据  -->
    <div class="history-ai-infor" v-if="showHistoryAiInfor" v-html="computedHistoryMD"></div>

    <!-- 加载状态提示 -->
    <div class="is-streaming" v-if="isStreaming">
      <!-- 加载状态提示 -->
      <img class="loading-img" :src="require('@/assets/images/Loading.gif')" alt="" />
      <span>正在联网搜索相关人物，请耐心等待...</span>
    </div>
    <!--    <div v-else style="height: 20px"></div>-->

    <!-- 思考过程url详情dialog -->
    <el-dialog
      append-to-body
      destroy-on-close
      :lock-scroll="true"
      :title="`${scholarName} - 个人资料`"
      :visible.sync="dialogUrlVisible"
      @close="closeThinkingDialog"
    >
      <div class="dialog-content" v-loading="dialogUrlLoading" v-html="dialogUrlContent"></div>
    </el-dialog>
  </div>
</template>

<script>
import ToggleComponent from '@/components/ToggleComponent.vue';
import { AI_API_URL } from '@/api/baseAPi.js';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify'; // HTML 消毒库
import 'github-markdown-css';
import _ from 'lodash';

export default {
  name: 'AiPersonalInformation',
  components: {
    ToggleComponent, // 展开收起组件
  },
  props: [
    'scholarName', // 专家姓名
    'scholarOrg', // 专家机构
    'scholarId', // 专家id
    'isAutoScroll', // 是否自动滚动
  ],
  data() {
    return {
      streamThinkingData: '', // 流式回答的思考过程
      streamAnswerData: '', // 流式回答文本内容
      streamBuffer: '', // 数据缓冲区
      isStreaming: false, // 流式请求状态标识

      // MarkdownIt配置
      md: new MarkdownIt({
        html: false, // 禁止原生HTML（提高安全性）
        breaks: false, // 禁止单换行转 <br>
        linkify: true, // 自动识别链接
        typographer: true, // 优化排版
      }),

      tipsType: true, // false:未收录 true:已收录
      showHistoryAiInfor: false, // 是否显示历史ai个人资料
      historyAiPersonalInforData: '', // 历史记录的ai个人资料字符串数据
      historyAiThinkingData: [], // 历史记录的思考过程数据
      historyAiLoading: true, // 历史记录的loading

      dialogUrlVisible: false, // 弹窗是否显示
      dialogUrlContent: '', // 弹窗的md格式字符串数据
      dialogUrlLoading: false, // 弹窗loading

      computedAnswerMD: '', // 格式化后的答案
      computedThinkingMD: '', // 格式化后的思考过程
      computedHistoryMD: '', // 格式化后的历史数据

      abortController: null, // 用于存储当前的AbortController实例
    };
  },
  created() {
    // 在生命周期钩子中初始化缓存对象
    this._mdCache = {};

    this.getAiPersonalInfor();
  },
  computed: {
    // // 使用md实时格式化正在回答中的答案
    // computedAnswerMD() {
    //   return this.markdownItFn(this.streamAnswerData);
    // },
    //
    // // 使用md实时格式化思考过程
    // computedThinkingMD() {
    //   return this.markdownItFn(this.streamThinkingData);
    // },
    //
    // // 使用md格式化历史答案
    // computedHistoryMD() {
    //   return this.markdownItFn(this.historyAiPersonalInforData);
    // },
  },
  watch: {
    // 监听数据变化，使用md实时格式化正在回答中的答案
    streamAnswerData: {
      immediate: true,
      handler: _.debounce(function (val) {
        this.computedAnswerMD = this.markdownItFn(val);
      }, 100),
    },
    // 监听数据变化，使用md实时格式化思考过程
    streamThinkingData: {
      immediate: true,
      handler: _.debounce(function (val) {
        this.computedThinkingMD = this.markdownItFn(val);
      }, 100),
    },
    // 监听数据变化，使用md格式化历史答案
    historyAiPersonalInforData: {
      immediate: true,
      handler: _.debounce(function (val) {
        this.computedHistoryMD = this.markdownItFn(val);
      }, 100),
    },
  },
  methods: {
    // 点击ai检索按钮
    async startStream() {
      if (this.isStreaming) return;

      this.tipsType = false; // 修改tips状态-未收录
      this.showHistoryAiInfor = false; // 隐藏历史ai个人资料
      this.isStreaming = true; // 流式请求状态-请求中
      this.streamAnswerData = ''; // 累积的文本内容清空
      this.streamThinkingData = ''; // 累积的思考过程清空
      this.streamBuffer = ''; // 数据缓冲区清空
      this.historyAiThinkingData = []; // 历史思考过程清空

      // 定义params
      const params = {
        name: this.scholarName,
        orgName: this.scholarOrg,
        talent_id: this.scholarId,
      };
      // 定义接口地址
      const url = `${AI_API_URL}/talent_resume_generate_new`;
      // const url = `${AI_API_URL}/talent_resume_generate_stream_v2`;

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            // 'Authorization': 'Bearer your_token_here', // 替换实际Token
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });

        if (!response.ok) throw new Error(`HTTP错误 ${response.status}`);

        // 创建流式读取器
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');

        // 递归读取流数据
        const readChunk = async () => {
          const { done, value } = await reader.read();

          if (done) {
            this.processBuffer(); // 处理最后剩余数据
            this.isStreaming = false;
            // 调用保存数据接口
            this.saveAiPersonalInfor();
            // 修改tips显示状态
            this.tipsType = true;

            return;
          }

          // 解码并处理数据块
          this.streamBuffer += decoder.decode(value, { stream: true });
          this.processBuffer();

          // 继续读取下一个块
          await readChunk();
        };

        await readChunk();
      } catch (error) {
        console.error('请求失败:', error);
        this.isStreaming = false;
      }
    },

    // 处理流式数据
    processBuffer() {
      // 按换行符分割完整数据包
      // console.log(true.buffer)
      const packets = this.streamBuffer.split('\n');
      this.streamBuffer = packets.pop() || ''; // 保留不完整数据

      packets.forEach((packet) => {
        if (!packet.trim()) return;

        try {
          const cleanData = packet.replace(/^data: /, '');
          const parsed = JSON.parse(cleanData); // 合法的JSON

          switch (parsed.type) {
            case 'think_progress':
              // eslint-disable-next-line no-case-declarations
              const thinking = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              this.streamThinkingData += thinking;
              break;

            case 'text_chunk':
              // 自动转换Unicode转义字符
              // eslint-disable-next-line no-case-declarations
              const content = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              this.streamAnswerData += content;
              break;

            case 'complete':
              console.log('传输完成');
              break;

            case 'end':
              console.log('流式传输结束');
              break;

            case 'error':
              // eslint-disable-next-line no-case-declarations
              const errContent = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              this.streamAnswerData += errContent;
              break;
          }
        } catch (e) {
          console.warn('JSON解析错误:', e, '原始数据:', packet);
        }
      });
    },

    // 使用MarkdownIt格式化markdown数据
    markdownItFn(val) {
      if (!val) return '';

      // 生成基于内容的唯一缓存键
      const cacheKey = val.length > 100 ? `${val.slice(0, 20)}...${val.length}` : val;

      // 缓存命中直接返回
      if (this._mdCache[cacheKey]) {
        return this._mdCache[cacheKey];
      }

      // 否则进行转换，处理新内容
      const result = DOMPurify.sanitize(this.md.render(val));

      // 更新缓存
      this._mdCache[cacheKey] = result;

      // 控制缓存大小（最多20条）
      const keys = Object.keys(this._mdCache);
      if (keys.length > 20) {
        // 删除第一个缓存（最老的）
        delete this._mdCache[keys[0]];
      }

      return result;
    },

    // 根据专家id获取AI生成的个人资料
    getAiPersonalInfor: _.debounce(function () {
      // this.historyAiLoading = true;
      const params = {
        talentId: this.scholarId,
      };
      // 定义接口地址
      const url = `${AI_API_URL}/get_talent_resume`;

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      })
        .then((res) => res.json())
        .then((data) => {
          // 如果有历史数据，显示历史数据模块 + 赋值
          if (data.status_code === 200 && data.resume.length > 0) {
            this.showHistoryAiInfor = true;
            this.tipsType = true;
            this.historyAiPersonalInforData = data.resume;
            if (Array.isArray(data.url_contents)) {
              this.historyAiThinkingData = data.url_contents;
            }

            this.streamThinkingData = '';
            this.streamAnswerData = '';
          } else {
            // 无数据时自动调用AI检索
            this.startStream();
            this.tipsType = false;
          }
        })
        .finally(() => {
          this.historyAiLoading = false;
        });
    }, 1000),

    // 生成数据后保存到数据库
    saveAiPersonalInfor() {
      const params = {
        talentId: this.scholarId,
        resume: this.streamAnswerData,
      };
      // 定义接口地址
      const url = `${AI_API_URL}/save_talent_resume`;

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status_code === 200) {
            // console.log(data);

            // 保存数据后获取数据
            this.getAiPersonalInfor();
            // this.historyAiPersonalInforData = this.streamAnswerData;
          }
        });
    },

    // 查看思考过程url地址的详细内容
    lookUrlDetail(url, content) {
      // 取消上一次未完成的请求
      if (this.abortController) {
        this.abortController.abort();
      }

      this.dialogUrlLoading = true;
      this.dialogUrlVisible = true;

      // 创建新的AbortController
      this.abortController = new AbortController();

      const params = {
        talentId: this.scholarId,
        url: url,
        url_content: content,
      };

      fetch(`${AI_API_URL}/get_url_content_by_llm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
        signal: this.abortController.signal, // 绑定取消信号
      })
        .then((res) => {
          if (!res.ok) throw new Error('网络响应错误');
          return res.json();
        })
        .then((data) => {
          this.dialogUrlContent = this.markdownItFn(data.data);
        })
        .catch((err) => {
          if (err.name === 'AbortError') {
            console.log('请求已被取消');
          } else {
            console.error('请求错误:', err);
          }
        })
        .finally(() => {
          this.dialogUrlLoading = false;
          // 请求完成后清除控制器
          this.abortController = null;
        });
    },

    // 关闭弹窗
    closeThinkingDialog() {
      // 取消当前请求（如果存在）
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }

      this.dialogUrlContent = '';
      this.dialogUrlVisible = false;
    },
  },
  beforeUnmount() {
    this._mdCache = null; // 避免内存泄漏
  },
};
</script>

<style scoped lang="less">
.ai-personal-infor {
  position: relative;
  z-index: 99;
  text-align: left;
  padding: 25px 0;
  background-color: white;
  //min-height:800px;
  border-radius: 0 0 16px 16px;
  //background-color: #fff;

  .tips {
    font-size: 16px;
    color: #888;
  }

  .is-streaming {
    height: 20px;
    font-size: 14px;
    margin-top: 10px;
    color: #888;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      margin-right: 8px;
    }
  }

  .ai-search-btn {
    width: 130px;
    height: 34px;
    background: #ffffff;
    border-radius: 5px;
    display: flex;
    margin: 10px 0;
    align-items: center;
    justify-content: center;
    border: 1px solid #1241C9;
    font-size: 14px;
    color: #1241C9;

    /deep/ span {
      font-size: 15px !important;
      display: flex;
      align-items: center;
      font-weight: normal;
      justify-content: center;

      img {
        margin-left: 3px;
        margin-top: -2px;
      }
    }

    &.is-disabled {
      cursor: not-allowed;
      background-color: #f5f5f5;
      border-color: #888;

      /deep/ span {
        color: #888;
        font-size: 15px !important;
      }
    }
  }

  .thinking-con {
    line-height: 1.6;
    color: #888888;
    background-color: #efefee90;
    border-radius: 10px;
    padding: 15px;

    /deep/ p > em {
      font-style: normal;
      color: #888888 !important;
      display: block;

      strong {
        font-weight: normal;
      }
    }

    .url-item {
      display: flex;
      align-items: center;

      a {
        color: #999;
      }

      span {
        color: #2d8cf0;
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }

  .ai-infor-content,
  .history-ai-infor {
    margin-top: 10px;
    color: #344054;
    line-height: 1.8;

    /deep/ p,
    /deep/ strong,
    /deep/ li,
    /deep/ h4,
    /deep/ em {
      font-size: 16px;
    }

    /deep/ ol,
    /deep/ ul {
      list-style: inherit;
      margin-left: 20px;
    }

    /deep/ h3 {
      font-size: 18px;
      margin: 1em 0 0.4em;
    }
  }
}

/deep/ .el-dialog {
  margin-top: 10vh !important;
  height: 80vh;

  .el-dialog__body {
    padding: 0 0 10px 20px;

    .dialog-content {
      height: calc(80vh - 100px);
      overflow: auto;
      line-height: 1.6;
      font-size: 15px;
      padding-right: 20px;

      h1,
      h2,
      h3 {
        margin-top: 10px;
      }
      h1 {
        font-size: 18px;
      }
      h2 {
        font-size: 16px;
      }
      h3 {
        font-size: 14px;
      }
    }
  }
}
</style>
